import axios from '@/lib/axios';
import { PaymentTaskDocument, PurchaseOrderContractTaskDocument } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1080. 支払タスクファイル名編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_documents/:id/
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
  name: string;
};

const updatePaymentTaskDocument = (props: Props): Promise<PaymentTaskDocument> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_documents/${props.id}`,
    props
  );
};

export const useUpdatePaymentTaskDocument = () => {
  return useMutation({
    mutationFn: updatePaymentTaskDocument,
  });
};
